export function buildWhatsAppLink(number, message) {
    const clean = (number || "").replace(/\D/g, "");
    const encoded = encodeURIComponent(message || "");
    return `https://wa.me/${clean}?text=${encoded}`;
}

export function buildEnquiryMessage({ items, shopName, contactName, city, note }) {
    const lines = [];
    lines.push("Hello Gold by SRN,");
    lines.push("");
    lines.push("I'd like to enquire about the following pieces from your catalog:");
    lines.push("");
    items.forEach((it, i) => {
        lines.push(`${i + 1}. ${it.name} (SKU: ${it.sku}) — Qty: ${it.quantity}`);
        if (it.notes) lines.push(`   Note: ${it.notes}`);
    });
    lines.push("");
    if (shopName) lines.push(`Shop: ${shopName}`);
    if (contactName) lines.push(`Name: ${contactName}`);
    if (city) lines.push(`City: ${city}`);
    if (note) {
        lines.push("");
        lines.push(`Message: ${note}`);
    }
    lines.push("");
    lines.push("Please share wholesale rates & availability. Thank you.");
    return lines.join("\n");
}
